  /* Prevent duplicate GTM auto form-interaction pushes fired in quick succession. */
  (function dedupeGtmFormInteract() {
    window.dataLayer = window.dataLayer || [];

    if (window.dataLayer.__formInteractDedupePatched) return;
    window.dataLayer.__formInteractDedupePatched = true;

    var originalPush = window.dataLayer.push;
    var lastBaseSignature = '';
    var lastElementValue = '';
    var lastTimestamp = 0;
    var DEDUPE_WINDOW_MS = 1200;

    function normalizeString(value) {
      return ((value == null ? '' : value) + '').trim().toLowerCase();
    }

    function getFormActionFromPayload(payload) {
      if (!payload || typeof payload !== 'object') return '';

      var directAction = normalizeString(payload['gtm.formAction']);
      if (directAction) return directAction;

      var element = payload['gtm.element'];
      if (element && typeof element.getAttribute === 'function') {
        return normalizeString(element.getAttribute('action'));
      }

      return '';
    }

    window.dataLayer.push = function() {
      var args = Array.prototype.slice.call(arguments);

      if (args.length === 1) {
        var payload = args[0];
        if (payload && typeof payload === 'object' && payload.event === 'gtm.formSubmit') {
          var formAction = getFormActionFromPayload(payload);
          if (formAction && formAction.indexOf('/cart/add') !== -1) {
            return window.dataLayer.length;
          }
        }

        if (payload && typeof payload === 'object' && payload.event === 'gtm.formInteract') {
          var elementId = normalizeString(payload['gtm.elementId']);
          var elementName = normalizeString(payload['gtm.elementName']);
          var elementType = normalizeString(payload['gtm.elementType']);
          var elementClasses = normalizeString(payload['gtm.elementClasses']);
          var formId = normalizeString(payload['gtm.formId']);
          var formName = normalizeString(payload['gtm.formName']);
          var elementValue = normalizeString(payload['gtm.elementValue']);
          var baseSignature = [
            payload.event,
            elementId,
            elementName,
            elementType,
            elementClasses,
            formId,
            formName,
            window.location.pathname,
          ].join('|');
          var now = Date.now();

          var withinWindow = now - lastTimestamp < DEDUPE_WINDOW_MS;
          var sameBaseSignature = baseSignature === lastBaseSignature;
          var sameValue = elementValue === lastElementValue;
          var oneValueMissing = !elementValue || !lastElementValue;

          if (withinWindow && sameBaseSignature && (sameValue || oneValueMissing)) {
            return window.dataLayer.length;
          }

          lastBaseSignature = baseSignature;
          lastElementValue = elementValue;
          lastTimestamp = now;
        }
      }

      return originalPush.apply(window.dataLayer, args);
    };
  })();

  document.addEventListener("DOMContentLoaded", function() {
  document.body.addEventListener("click", function(e) {
    // Check if the clicked element (or any of its parents) matches the class
    const targetButton = e.target.closest(".open-cookie-popups");
    
    if (targetButton) {
      e.preventDefault();

        // Prefer OneTrust API when available; fall back to the SDK button click.
        if (window.OneTrust && typeof window.OneTrust.ToggleInfoDisplay === "function") {
          window.OneTrust.ToggleInfoDisplay();
          return;
        }

        const otBtn = document.getElementById("ot-sdk-btn");
        if (otBtn) {
          otBtn.click();
        }
    }
  });
});




  if (!window.__themeLegacyAddToCartSubmitBound) {
    window.__themeLegacyAddToCartSubmitBound = true;

  document.body.addEventListener('submit', function(e) {
    if (e.__themeLegacyAddToCartHandled) {
      return;
    }

    const form = e.target.closest('#AddToCartForm');
    if (!form) {
      return;
    }

    e.__themeLegacyAddToCartHandled = true;

    e.preventDefault();

    const btn = form.querySelector('#AddToCart');
    const btnText = 'ADD TO BAG';
    if (btn) {
      btn.setAttribute('disabled', 'disabled');
    }

    const formData = new FormData(form);
    const requestBody = new URLSearchParams(formData).toString();

    const handleError = function(response) {
      if (response && response.description && btn) {
        const error = document.createElement('p');
        error.className = 'error';
        error.textContent = response.description;
        btn.insertAdjacentElement('afterend', error);

        setTimeout(function() {
          error.style.opacity = '0';
          setTimeout(function() {
            error.remove();
          }, 300);
        }, 4000);
      }

      if (btn) {
        btn.value = btnText;
        btn.removeAttribute('disabled');
      }
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json'
      },
      body: requestBody
    })
      .then(async function(response) {
        if (!response.ok) {
          let errorResponse = null;
          try {
            errorResponse = await response.json();
          } catch (error) {
            errorResponse = { description: 'Unable to add this item to cart.' };
          }
          throw errorResponse;
        }
        return response.json();
      })
      .catch(function(errorResponse) {
        handleError(errorResponse);
        return null;
      })
      .then(function(data) {
        if (!data) {
          return;
        }
      //addToCartSuccess();
      function callback() {
        document.querySelectorAll('.remodal-overlay, .remodal-wrapper').forEach(function(element) {
          element.classList.remove('remodal-is-opened');
          element.classList.add('remodal-is-closed');
        });

        const supportsJsElement = document.querySelector('.supports-js');
        if (supportsJsElement) {
          supportsJsElement.classList.remove('remodal-is-locked');
        }

        document.querySelectorAll('.remodal-is-closed').forEach(function(element) {
          element.style.display = 'none';
        });

        fetch(window.location.pathname)
          .then(function(response) {
            return response.text();
          })
          .then(function(pageHtml) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(pageHtml, 'text/html');
            const miniCartSource = doc.querySelector('#mini-cart');
            const miniCartTarget = document.querySelector('#mini-cart');

            if (miniCartSource && miniCartTarget) {
              miniCartTarget.innerHTML = miniCartSource.innerHTML;
            }

            const closeButton = document.querySelector('#mini-cart .close .fa-times');
            if (closeButton) {
              closeButton.addEventListener('click', function() {
                const miniCart = document.querySelector('#mini-cart');
                if (miniCart) {
                  miniCart.style.display = 'none';
                }
              });
            }
          });

        const miniCart = document.querySelector('#mini-cart');
        if (miniCart) {
          miniCart.style.display = 'block';
        }

        window.scrollTo({top: 0, behavior: 'smooth'});
        fetch('/cart.js')
          .then(function(response) {
            return response.json();
          })
          .then(function(cart) {
            document.querySelectorAll('.mobile-icon-cart .total, #header-menu li .total').forEach(function(element) {
              element.innerHTML = cart.item_count;
            });
          });

        var expectedShipDate = data.properties != null ? data.properties['EXPECTED SHIP DATE'] != null ? data.properties['EXPECTED SHIP DATE'] : '' : '';
        var colorValue = '';
        var sizeValue = '';
        if (Array.isArray(data.variant_options)) {
          colorValue = (data.variant_options[0] || '').toString().trim();
          sizeValue = (data.variant_options[1] || '').toString().trim();
        }

        window.dataLayer = window.dataLayer || [];
        var isPreOrder = data.properties != null && data.properties['PRE-ORDER'] ? true : false;
        var isBackOrder = data.properties != null && data.properties['BACK-ORDER'] ? true : false;
        
        var dlProduct = {
          id: data.product_id,
          sku: data.variant_id,
          style: data.sku,
          name: data.title,
          price: (parseInt(data.final_price)/100).toFixed(2),
          basePrice: (parseInt(data.original_price)/100).toFixed(2),
          quantity: data.quantity,
          brand: data.vendor,
          color: colorValue,
          colorFamily: colorValue,
          size: sizeValue,
          expectedShipDate: expectedShipDate
        };
        
        var isQuickViewModalAdd = !!form.closest('.quick-add-modal, #quick-add-dialog, quick-add-dialog');

        window.dataLayer.push({
          event: 'addToCart',
          addToCart: {
            products: [dlProduct],
            IsPreOrder: isPreOrder,
            IsBackOrder: isBackOrder,
            expectedShipDate: expectedShipDate || data.properties['EXPECTED SHIP DATE'] || '',
            addToCartLocation: window.addToCartLocationOverride || (isQuickViewModalAdd ? 'Collection Page' : 'Product Page'),
          },
          _clear: true,
        });
      }

      callback();
    });
  });
  }

  (function setupEcommerceTracking() {
    if (window.__themeEcommerceTrackingBound) {
      return;
    }
    window.__themeEcommerceTrackingBound = true;

    var quickViewPending = {};
    /** @type {Record<string, Record<string, boolean>>} */
    var viewedItemsByList = {};
    /** @type {Record<string, number>} */
    var recentAddToCartEvents = {};
    var ADD_TO_CART_DEDUPE_WINDOW_MS = 3000;

    function getFreshQuickViewPending(key) {
      if (!key) return null;

      var entry = quickViewPending[key];
      if (!entry) return null;

      if (Date.now() - entry.ts >= 20000) {
        delete quickViewPending[key];
        return null;
      }

      return entry;
    }

    function pushDataLayer(payload) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }

    function cleanupRecentAddToCartEvents(now) {
      Object.keys(recentAddToCartEvents).forEach(function(signature) {
        if (now - recentAddToCartEvents[signature] > ADD_TO_CART_DEDUPE_WINDOW_MS) {
          delete recentAddToCartEvents[signature];
        }
      });
    }

    function getAddToCartSignature(payload) {
      if (!payload || payload.event !== 'addToCart') return '';

      var product =
        payload.addToCart && Array.isArray(payload.addToCart.products) && payload.addToCart.products.length
          ? payload.addToCart.products[0]
          : null;

      if (!product) return '';

      var id = (product.id || '').toString();
      var sku = (product.sku || '').toString();
      var qty = Number(product.quantity || 1);
      var quantity = Number.isFinite(qty) ? qty : 1;
      var location =
        payload.addToCart && payload.addToCart.addToCartLocation
          ? payload.addToCart.addToCartLocation.toString()
          : '';

      return [id, sku, quantity, location, window.location.pathname].join('|');
    }

    function pushAddToCartPayload(payload) {
      var signature = getAddToCartSignature(payload);
      var now = Date.now();

      cleanupRecentAddToCartEvents(now);

      if (signature && recentAddToCartEvents[signature] && now - recentAddToCartEvents[signature] < ADD_TO_CART_DEDUPE_WINDOW_MS) {
        return;
      }

      if (signature) {
        recentAddToCartEvents[signature] = now;
      }

      pushDataLayer(payload);
    }

    function textContentOrEmpty(element) {
      return element && element.textContent ? element.textContent.trim() : '';
    }

    function parsePriceFromContext(context) {
      if (!context) return '';

      var priceElement =
        context.querySelector('.price-item--sale') ||
        context.querySelector('.price-item--regular') ||
        context.querySelector('.price');

      var rawPrice = textContentOrEmpty(priceElement).replace(/[^0-9.,]/g, '').replace(',', '.');
      if (!rawPrice) return '';

      var parsed = parseFloat(rawPrice);
      return Number.isFinite(parsed) ? parsed.toFixed(2) : '';
    }

    function getProductContextFromNode(node) {
      if (!(node instanceof Element)) return null;

      var gridItem = node.closest('.product-grid__item');
      var productCard = node.closest('product-card');
      var formComponent = node.closest('product-form-component');
      var container = gridItem || productCard || formComponent;
      if (!container) return null;

      var productId =
        (container.getAttribute('data-product-id') ||
          (formComponent && formComponent.getAttribute('data-product-id')) ||
          '').toString();

      var variantId =
        (container.getAttribute('data-variant-id') ||
          (formComponent && formComponent.querySelector('input[name="id"]')
            ? formComponent.querySelector('input[name="id"]').value
            : '') ||
          '').toString();

      var titleElement =
        (container.querySelector && container.querySelector('.title-text')) ||
        (container.querySelector && container.querySelector('product-title a')) ||
        (container.querySelector && container.querySelector('h1, h2, h3'));

      var productName = textContentOrEmpty(titleElement);
      var price = parsePriceFromContext(container);
      var color = (gridItem && gridItem.getAttribute('data-color-value')) || '';

      return {
        id: productId,
        sku: variantId,
        name: productName,
        price: price,
        color: color,
        colorFamily: color,
      };
    }

    function formatPriceValue(value) {
      var parsed = Number(value);
      return Number.isFinite(parsed) ? parsed.toFixed(2) : '';
    }

    function getPdpContextFallback(productId, variantId) {
      var productData = window.dataLayerData && window.dataLayerData.product ? window.dataLayerData.product : null;
      if (!productData) return null;

      var fallbackProductId = (productId || productData.id || '').toString();
      var variants = Array.isArray(productData.variants) ? productData.variants : [];
      var matchingVariant =
        variantId && variants.length
          ? variants.find(function(variant) {
              return (variant && variant.id != null ? variant.id.toString() : '') === variantId.toString();
            })
          : null;

      var colorInput = document.querySelector(
        'variant-picker fieldset[data-option-name="color"] input:checked, variant-picker fieldset[data-option-name="color"] option[selected]'
      );
      var colorValue = '';
      if (colorInput instanceof HTMLInputElement) {
        colorValue = (colorInput.value || '').toString().trim();
      } else if (colorInput instanceof HTMLOptionElement) {
        colorValue = (colorInput.textContent || '').toString().trim();
      }

      return {
        id: fallbackProductId,
        sku: (variantId || (matchingVariant && matchingVariant.id) || '').toString(),
        name:
          (productData.name || '').toString() ||
          textContentOrEmpty(document.querySelector('main h1, .main-page-title, .product-title h1')),
        price:
          (matchingVariant && matchingVariant.price != null
            ? formatPriceValue(matchingVariant.price)
            : formatPriceValue(productData.price)) || '',
        color: colorValue,
        colorFamily: colorValue,
      };
    }

    function getListName() {
      var heading = document.querySelector('main h1, .collection-title, .main-page-title');
      return textContentOrEmpty(heading) || 'Product Listing';
    }

    /** @param {Element | null | undefined} element */
    function isElementVisible(element) {
      if (!(element instanceof Element)) return false;
      if (element.closest('[hidden]')) return false;

      var style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return false;

      return element.getClientRects().length > 0;
    }

    /** @param {Element} card */
    function isCardInVisibleSlide(card) {
      var slide = card.closest('slideshow-slide');
      if (!(slide instanceof Element)) return true;
      if (slide.hasAttribute('hidden')) return false;
      return slide.getAttribute('aria-hidden') !== 'true';
    }

    /** @param {Element} card */
    function getListContainerFromCard(card) {
      return (
        card.closest('[data-analytics-list-id]') ||
        card.closest('[data-testid="product-list"]') ||
        card.closest('.section-resource-list') ||
        card.closest('.product-grid-container') ||
        card.closest('results-list') ||
        card.closest('main')
      );
    }

    /** @param {Element} card */
    function getListMetadataFromCard(card) {
      var listContainer = getListContainerFromCard(card);
      var listId = '';
      var listName = '';

      if (listContainer instanceof Element) {
        listId =
          listContainer.getAttribute('data-analytics-list-id') ||
          listContainer.getAttribute('data-testid') ||
          listContainer.id ||
          '';

        listName =
          listContainer.getAttribute('data-analytics-list-name') ||
          textContentOrEmpty(listContainer.querySelector('h1, h2, h3, .main-page-title, .collection-title')) ||
          '';
      }

      if (!listName) {
        listName = getListName();
      }

      if (!listId) {
        listId = listName;
      }

      return {
        container: listContainer,
        listId: listId,
        listName: listName,
      };
    }

    /**
     * @param {Element} card
     * @param {Element | null} listContainer
     */
    function getCardIndexInList(card, listContainer) {
      if (!(listContainer instanceof Element)) return 1;

      var cardsInList = Array.from(listContainer.querySelectorAll('product-card[data-product-id]')).filter(function(node) {
        return node instanceof Element && isElementVisible(node);
      });

      var index = cardsInList.indexOf(card);
      return index >= 0 ? index + 1 : 1;
    }

    function trackViewItemList() {
      var cards = Array.from(document.querySelectorAll('product-card[data-product-id]'));
      if (!cards.length) return;

      /** @type {Record<string, { listId: string, listName: string, items: Array<Record<string, string | number>> }>} */
      var listItems = {};

      cards.forEach(function(card) {
        if (!(card instanceof Element)) return;
        if (!isElementVisible(card)) return;
        if (!isCardInVisibleSlide(card)) return;

        var ctx = getProductContextFromNode(card);
        if (!ctx || !ctx.id) return;

        var listMeta = getListMetadataFromCard(card);
        var listKey = listMeta.listId || listMeta.listName;
        if (!listKey) return;

        var seenInList = viewedItemsByList[listKey] || {};
        var itemSeenKey = [ctx.id, ctx.sku].join(':');
        if (seenInList[itemSeenKey]) return;

        if (!listItems[listKey]) {
          listItems[listKey] = {
            listId: listMeta.listId,
            listName: listMeta.listName,
            items: [],
          };
        }

        var currentList = listItems[listKey];
        if (!currentList) return;

        currentList.items.push({
          item_id: ctx.id,
          item_variant: ctx.sku,
          item_name: ctx.name,
          price: ctx.price,
          index: getCardIndexInList(card, listMeta.container),
          item_list_id: listMeta.listId,
          item_list_name: listMeta.listName,
        });
      });

      Object.keys(listItems).forEach(function(listKey) {
        var listPayload = listItems[listKey];
        if (!listPayload) return;
        if (!listPayload.items.length) return;

        pushDataLayer({
          event: 'view_item_list',
          ecommerce: {
            item_list_id: listPayload.listId,
            item_list_name: listPayload.listName,
            items: listPayload.items,
          },
        });

        var viewedForList = viewedItemsByList[listKey] || {};
        listPayload.items.forEach(function(item) {
          var itemKey = [item.item_id, item.item_variant].join(':');
          viewedForList[itemKey] = true;
        });
        viewedItemsByList[listKey] = viewedForList;
      });
    }

    function scheduleViewItemListTracking() {
      clearTimeout(scheduleViewItemListTracking._timer);
      scheduleViewItemListTracking._timer = setTimeout(trackViewItemList, 120);
    }

    document.addEventListener('DOMContentLoaded', function() {
      scheduleViewItemListTracking();

      var resultsContainer = document.querySelector('results-list, #ResultsList, .product-grid-container');
      if (resultsContainer instanceof Element) {
        var observer = new MutationObserver(function() {
          scheduleViewItemListTracking();
        });

        observer.observe(resultsContainer, { childList: true, subtree: true });
      }
    });

    document.addEventListener('slideshow:select', function() {
      scheduleViewItemListTracking();
    });

    document.addEventListener('recently-viewed:rendered', function() {
      scheduleViewItemListTracking();
    });

    window.addEventListener('resize', function() {
      scheduleViewItemListTracking();
    });

    document.addEventListener('click', function(event) {
      if (!(event.target instanceof Element)) return;

      var productLink = event.target.closest('.product-card__link, [ref="cardGalleryLink"], [ref="productTitleLink"]');
      if (productLink) {
        var selectedCtx = getProductContextFromNode(productLink);
        if (selectedCtx && selectedCtx.id) {
          pushDataLayer({
            event: 'select_item',
            ecommerce: {
              item_list_name: getListName(),
              items: [
                {
                  item_id: selectedCtx.id,
                  item_variant: selectedCtx.sku,
                  item_name: selectedCtx.name,
                  price: selectedCtx.price,
                },
              ],
            },
          });
        }
      }

      var quickViewButton = event.target.closest('.quick-add__button--choose');
      if (quickViewButton) {
        var quickViewCtx = getProductContextFromNode(quickViewButton);
        if (quickViewCtx && quickViewCtx.id) {
          quickViewPending[quickViewCtx.id] = {
            ts: Date.now(),
            product: quickViewCtx,
          };

          if (quickViewCtx.sku) {
            quickViewPending[quickViewCtx.sku] = {
              ts: Date.now(),
              product: quickViewCtx,
            };
          }

          pushDataLayer({
            event: 'view_item',
            ecommerce: {
              items: [
                {
                  item_id: quickViewCtx.id,
                  item_variant: quickViewCtx.sku,
                  item_name: quickViewCtx.name,
                  price: quickViewCtx.price,
                },
              ],
            },
          });
        }
      }
    });

    document.addEventListener('submit', function(event) {
      if (event.__themeEcommerceSubmitHandled) return;

      if (!(event.target instanceof HTMLFormElement)) return;
      if (event.defaultPrevented) return;

      var form = event.target;
      var action = (form.getAttribute('action') || '').toLowerCase();
      if (!action || action.indexOf('/cart/add') === -1) return;

      event.__themeEcommerceSubmitHandled = true;

      var formData = new FormData(form);
      var productId =
        (formData.get('product-id') ||
          (form.closest('product-form-component') && form.closest('product-form-component').getAttribute('data-product-id')) ||
          '') +
        '';
      var variantId = (formData.get('id') || '').toString();
      var quantityValue = Number(formData.get('quantity') || 1);
      var quantity = Number.isFinite(quantityValue) ? quantityValue : 1;

      var ctx = getProductContextFromNode(form) || {};
      var pdpFallbackCtx = getPdpContextFallback(productId || ctx.id || '', variantId || ctx.sku || '');
      if (pdpFallbackCtx) {
        ctx = {
          id: ctx.id || pdpFallbackCtx.id,
          sku: ctx.sku || pdpFallbackCtx.sku,
          name: ctx.name || pdpFallbackCtx.name,
          price: ctx.price || pdpFallbackCtx.price,
          color: ctx.color || pdpFallbackCtx.color,
          colorFamily: ctx.colorFamily || pdpFallbackCtx.colorFamily,
        };
      }

      if (!(productId || ctx.id || variantId || ctx.sku)) return;

      var isQuickViewAdd = !!form.closest('.quick-add-modal, #quick-add-dialog, quick-add-dialog, .quick-add');

      var dlProduct = {
        id: productId || ctx.id || '',
        sku: variantId || ctx.sku || '',
        name: ctx.name || '',
        price: ctx.price || '',
        quantity: quantity,
        color: ctx.color || '',
        colorFamily: ctx.colorFamily || '',
      };

      pushAddToCartPayload({
        event: 'addToCart',
        addToCart: {
          products: [dlProduct],
          IsPreOrder: false,
          IsBackOrder: false,
          expectedShipDate: '',
          addToCartLocation: window.addToCartLocationOverride || (isQuickViewAdd ? 'Collection Page' : 'Product Page'),
        },
        _clear: true,
      });
    });

    document.addEventListener('cart:update', function(event) {
      if (event.__themeEcommerceCartUpdateHandled) return;
      event.__themeEcommerceCartUpdateHandled = true;

      if (!event || !event.detail || !event.detail.data) return;
      if (event.detail.data.didError) return;

      var data = event.detail.data;
      if (data.source !== 'product-form-component' && data.source !== 'quick-order-quantity') return;

      var productId = (data.productId || '').toString();
      var variantId = (data.variantId || event.detail.sourceId || '').toString();
      var quantity = Number(data.itemCount || 1);

      var nodeForLookup = null;
      if (productId) {
        nodeForLookup =
          document.querySelector('.product-grid__item[data-product-id="' + productId + '"]') ||
          document.querySelector('product-form-component[data-product-id="' + productId + '"]');
      }

      var ctx = getProductContextFromNode(nodeForLookup || document.body) || {};

      var pendingByProduct = getFreshQuickViewPending(productId);
      var pendingByVariant = getFreshQuickViewPending(variantId);
      var isQuickViewAdd = !!(pendingByProduct || pendingByVariant);

      if (!ctx.id && pendingByProduct && pendingByProduct.product) {
        ctx = pendingByProduct.product;
      }

      if (!ctx.id && pendingByVariant && pendingByVariant.product) {
        ctx = pendingByVariant.product;
      }

      var pdpFallbackCtx = getPdpContextFallback(productId || ctx.id || '', variantId || ctx.sku || '');
      if (pdpFallbackCtx) {
        ctx = {
          id: ctx.id || pdpFallbackCtx.id,
          sku: ctx.sku || pdpFallbackCtx.sku,
          name: ctx.name || pdpFallbackCtx.name,
          price: ctx.price || pdpFallbackCtx.price,
          color: ctx.color || pdpFallbackCtx.color,
          colorFamily: ctx.colorFamily || pdpFallbackCtx.colorFamily,
        };
      }

      if (!(productId || ctx.id || variantId || ctx.sku)) return;

      var dlProduct = {
        id: productId || ctx.id || '',
        sku: variantId || ctx.sku || '',
        name: ctx.name || '',
        price: ctx.price || '',
        quantity: Number.isFinite(quantity) ? quantity : 1,
        color: ctx.color || '',
        colorFamily: ctx.colorFamily || '',
      };

      var payload = {
        event: 'addToCart',
        addToCart: {
          products: [dlProduct],
          IsPreOrder: false,
          IsBackOrder: false,
          expectedShipDate: '',
          addToCartLocation: window.addToCartLocationOverride || (isQuickViewAdd ? 'Collection Page' : 'Product Page'),
        },
        _clear: true,
      };

      pushAddToCartPayload(payload);

      var pendingByProductId = quickViewPending[productId];
      if (pendingByProductId && Date.now() - pendingByProductId.ts < 20000) {
        delete quickViewPending[productId];
      }

      var pendingByVariantId = quickViewPending[variantId];
      if (pendingByVariantId && Date.now() - pendingByVariantId.ts < 20000) {
        delete quickViewPending[variantId];
      }
    });
  })();
